import { ADDRESS_FIAS_LEVEL_CITY } from '@sravni/cosago-react-library/lib/validationSchemes';

import type { TDadataFullAddressSelectOption } from 'shared/types';

const MILITARY_ADDRESS_REGEXP = /(в\/ч|воинская)\s.+$/i;

/**
 * Проверяет, что адрес можно считать военной частью, если:
 * - в строке есть "в/ч" или "воинская",
 * - уровень ФИАС не ниже города.
 *
 * Примеры:
 * - "в/ч 12345" + fias_level: 4 -> true
 * - "воинская часть 12345" + fias_level: 4 -> true
 * - "ул Ленина, д 10" -> false
 */
export const isMilitaryAddress = (addressPart: string, data: TDadataFullAddressSelectOption['data']) => {
  const { fias_level } = data;

  const hasAddressPart = Boolean(addressPart);
  const hasAllowedFiasLevel = Number(fias_level) >= ADDRESS_FIAS_LEVEL_CITY;
  const hasMilitaryMarker = MILITARY_ADDRESS_REGEXP.test(addressPart);

  return hasAddressPart && hasAllowedFiasLevel && hasMilitaryMarker;
};
